import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage/LandingPage';

/**
 * AppRoutes - Centralized routing component
 * @param {Object} props
 * @param {Function} props.renderMainContent - Function to render main screen content
 */
const AppRoutes = ({ renderMainContent, landingPageData, onLandingReportNow, onNarrativeClick }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={(
          <LandingPage
            {...landingPageData}
            onReportNow={onLandingReportNow}
            onNarrativeClick={onNarrativeClick}
          />
        )}
      />
      <Route path="/entities" element={renderMainContent()} />
    </Routes>
  );
};

export default AppRoutes;
